import React from 'react';
import Form from 'react-bootstrap/Form';
import HintCard from '../common/HintCard/HintCard';

export const hintCardType = {
    policy:'policy',
    portfolio:'portfolio',
    strat:'strat',
    proj:'proj',
}

export default function HintCardText({ projs ,...rest}) {
    const {type} = {...rest}

    const text = projs.map((e, i) => (
    <div key={i} className="mb-1">
        <span style={addWFontWeightStyle}>{e.fullNumber}</span>
      {' '}
      {e.name}
      , руководитель проекта:
      {' '}
      {e.head.displayName}
        { !!e?.policyId && ', Политика цифровой трансформации'}
        { !!e?.strategyId && ', реализуемого в рамках стратегического проекта'}
        {!!e?.strategyId && ' '}
        {!!e?.strategyId && e.strategyName}
      , % участия –
      {' '}
        <span style={addWFontWeightStyle}>{e.share * 100}</span>
    </div>
  ));

  text.unshift(<h6 className="mb-2" key={-1}>Другие проекты, в которых добавлен участник</h6>);

  return (
    <>
      <HintCard
        cardStyles={{
          fontSize: '18px',
          marginTop: 0,
          fontsize: '18px',
          border: '1px solid #FFECB5',
        }}
        noGutter
        rowStyles={{ padding: 0, margin: 'auto', marginBottom: '1em' }}
        resultHeaderStyle={{ backgroundColor: '#FFF3CD', color: '#664D03', fontWeight: '600' }}
        text={text}
      />
    </>
  );
}

const addWFontWeightStyle = {
    fontWeight:600
}
